import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import jwt from 'jsonwebtoken';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import RetailPage from 'src/containers/Page/RetailPage';
import BreadCrumb from 'src/components/Retail/BreadCrumb/BreadCrumb';
import Button from 'src/components/Button/Button';
import TillOverview from '../Transactions/components/TillOverview/TillOverview';
import { RootState } from 'src/configs/store';
import './EndShift.scss';
import EndShiftModal from './Modal/EndShiftModal';
import classNames from 'classnames';

function Endshift() {
  const { tillUser } = useSelector((state:RootState) => state.auth);
  const { transactionTypeList } = useSelector((state:RootState) => state.account);
  const { tillHistory } = useSelector((state:RootState) => state.peripherals);


  const decodedToken: any = jwt.decode(tillUser);

  const [coins, handleCoins] = useState(0);
  const [freeValue, setFreeValue] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [money, setMoney] = useState({
    bills:[
      { id:0, name: 'R200', value:200, lineTotal:0, currentValue:0, info: '', isInputCount: true, isInputAmount: true,
        hasSingleValue: true, isCashTotal: true },
      { id:0, name: 'R100', value:100, lineTotal:0, currentValue:0, info: '', isInputCount: true,  isInputAmount: true,
        hasSingleValue: true, isCashTotal: true },
      { id:0, name: 'R50', value:50, lineTotal:0, currentValue:0, info: '', isInputCount: true, isInputAmount: true,
        hasSingleValue: true, isCashTotal: true },
      { id:0, name: 'R20', value:20, lineTotal:0, currentValue:0, info: '', isInputCount: true, isInputAmount: true,
        hasSingleValue: true, isCashTotal: true },
      { id:0, name: 'R10', value:10, lineTotal:0, currentValue:0, info: '', isInputCount: true, isInputAmount: true,
        hasSingleValue: true, isCashTotal: true }
    ]
  });

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const loadTransactionTypes = async () => {
    if (_.isEmpty(transactionTypeList)){
      await dispatch.account.getTransactionTypes();
    }
  };

  const loadDenoms = async () => {
    const bills = await dispatch.peripherals.getDenominators();
    const newBills = _.map(_.sortBy(bills, 'sortId'), (bill) => {

      if (bill.singleValue > 0){
        return { id: bill.id, name: bill.text, value: bill.singleValue, lineTotal: 0, currentValue: 0, info: '',
          isInputCount: bill.isInputCount, isInputAmount: bill.isInputAmount, hasSingleValue: bill.hasSingleValue, isCashTotal: bill.isCashTotal };
      }
      if (bill.value > 0){
        return { id: bill.id, name: bill.text, value: bill.value, lineTotal: 0, currentValue: 0, info: '',
          isInputCount: bill.isInputCount, isInputAmount: bill.isInputAmount, hasSingleValue: bill.hasSingleValue, isCashTotal: bill.isCashTotal };
      }
      return null;
    });

    setFreeValue(_.filter(bills, (bill) => bill.singleValue === 0));
    setMoney({ bills: _.compact(newBills) });
  };

  useEffect(() => {
    loadTransactionTypes();
    loadDenoms();
  }, []);

  const handleChange = (type: string) => (e) => {
    const currency = JSON.parse(JSON.stringify(money));
    const index = _.findIndex(currency[type], { name: e.target.name });
    currency[type][index].currentValue = +e.target.value;
    currency[type][index].lineTotal = +e.target.value * currency[type][index].value;
    setMoney(currency);
  };

  const clear = (e) => {
    e.preventDefault();
    const bills = _.map(money.bills, (bill) => {
      return { id: bill.id, name: bill.name, value:bill.value, lineTotal: 0, currentValue:0, info: '',
        isInputCount: bill.isInputCount, isInputAmount: bill.isInputAmount, hasSingleValue: bill.hasSingleValue, isCashTotal: bill.isCashTotal };
    });
    const newFreeValue = _.map(freeValue, (method) => {
      return { ...method, singleValue: 0.00, info: '' };
    });
    handleCoins(0);
    setMoney({ bills });
    setFreeValue(newFreeValue);
  };

  let sum = 0;

  sum = (_.filter(money.bills, (bill) => bill.isCashTotal)).reduce((accumulator, bill) => {
    return (accumulator + bill.lineTotal);
  }, 0);

  useEffect(() => {
    if (freeValue){
      const sum = (freeValue).reduce((accumulator, bill) => {
        return (accumulator + bill.singleValue);
      }, 0);
      handleCoins(sum);
    }
  }, [freeValue]);

  const handleText = (index, value) => {
    const bills = JSON.parse(JSON.stringify(money.bills));
    bills[index].info = value;
    setMoney({ bills });
  };

  const handleLineTotal = (index, value) => {
    const bills = JSON.parse(JSON.stringify(money.bills));
    bills[index].lineTotal = +value;
    bills[index].currentValue = value / bills[index].value;
    setMoney({ bills });
  };

  const handleSubmit = async (secondTry = false) => {

    const bills = _.compact(_.map(money.bills, (bill) => {
      if (bill.lineTotal > 0){
        return { id: bill.id, amount: bill.lineTotal, ...(bill.info !== '' && { info: bill.info }) };
      }
      return null;
    }));

    const payload = {
      denominations: [
        ...bills
      ],
      secondTry
    };

    const endShift = await dispatch.peripherals.endShiftSession(payload);
    if (!endShift){
      setShowModal(true);
    }
  };

  const handleModalSubmit = async () => {
    const previousValue = localStorage.getItem('fakeTill');
    localStorage.setItem('fakeTill', 'true');
    await handleSubmit(true);
    setShowModal(false);
    localStorage.setItem('fakeTill', previousValue);
  };

  return (
    <RetailPage>
      <BreadCrumb breadcrumbs={ [{ name: t('retail.home'), link:'/' }, { name: t('retail.endOfShift'), link: ''  }] } />
      <div className="end-shift">
        <div className="end-shift__wallets-container">
          <button className="end-shift__end-session" type="button" onClick={ () => handleSubmit(false) }>
            { t('endShift.closeTill') }
          </button>
        </div>
        <div className={
          classNames({
            'end-shift__overview': true,
            'end-shift__overview--hidden': !tillHistory && localStorage.getItem('fakeTill') !== 'true'
          })
        }
        >
          <div className="end-shift__container">
            <h4 className="end-shift__title">{ t('endShift.cashUp') }</h4>
            <div className="end-shift__calculations">
              <span className="end-shift__subtitle end-shift__subtitle--25" />
              <h5 className="end-shift__subtitle end-shift__subtitle--10">{ t('endShift.count') }</h5>
              <h5 className="end-shift__subtitle end-shift__subtitle--25">{ t('endShift.value') }</h5>
              <h5 className="end-shift__subtitle end-shift__subtitle--35">{ t('endShift.comment') }</h5>
              {
                _.map(money.bills, (bill, index) => {
                  return (
                    <div className="end-shift__row">
                      <span className="end-shift__info">{ bill.name }</span>
                      <div className="end-shift__input-container">
                        {
                          bill.isInputCount && <input
                            className="end-shift__input end-shift__input--small"
                            type="number"
                            autoComplete="new-password"
                            name={ bill.name }
                            placeholder="item"
                            onChange={ handleChange('bills') }
                            value={ bill.currentValue > 0 ? bill.currentValue : '' }
                          />
                        }
                        {
                          !(bill.isInputCount) &&
                          <span className="end-shift__input end-shift__input--disabled end-shift__input--small" />
                        }
                      </div>
                      {
                        bill.isInputAmount &&
                        <input
                          onChange={ (e) => handleLineTotal(index, e.target.value) }
                          type="number"
                          autoComplete="new-password"
                          name={ bill.name }
                          className="end-shift__input end-shift__input--medium"
                          value={ bill.lineTotal > 0 ? bill.lineTotal : '' }
                        />
                      }
                      {
                        !(bill.isInputAmount) &&
                        <span className="end-shift__input end-shift__input--medium end-shift__input--disabled">{ bill.lineTotal }</span>
                      }
                      <input
                        value={ bill.info }
                        className="end-shift__input"
                        onChange={ (e) => handleText(index, e.target.value) }
                        placeholder={ t('endShift.item') }
                      />
                    </div>
                  );
                }
                )
              }
              <span className="end-shift__info end-shift__info--bold">{ t('endShift.total') }</span>
              <span />
              <span className="end-shift__info end-shift__info--center">{ sum + coins }</span>
              { /* <span className="end-shift__info end-shift__info--bold">{ t('endShift.shortOver') }</span>
              <span />
              {
                overview.length !== 0 &&
              <>
                <span className={
                  classNames({
                    'end-shift__info': true,
                    'end-shift__info--green': (overview[0].totalDebits - overview[0].totalCredits) + (sum + credit + coins) > 0,
                    'end-shift__info--red': false
                  })
                }
                >{
                    (formatAmountToFixed(
                      ((overview[0].totalDebits - overview[0].totalCredits / overview[0]['type']['divisor'])) + (sum + credit + coins), 1)
                    )
                  }
                </span>
              </>
              } */ }
              <div className="end-shift__cashup-buttons">
                <Button type="button" text={ t('endShift.clear') } className="btn--outlined end-shift__cashup-button" onClick={ clear } />
              </div>
            </div>
          </div>
          <TillOverview userName={ decodedToken.username } isEndOfShift loginTime={ +localStorage.getItem('firstLogin') } />
        </div>
        <div className="end-shift__transaction">
          { /* <AddTransaction /> */ }
        </div>
        {
          showModal &&
            <EndShiftModal onClose={ () => setShowModal(false) } onSubmit={ handleModalSubmit } />
        }
      </div>
    </RetailPage>
  );
}

export default Endshift;
